'use client';

import { forwardRef, useId, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { ComboboxGroupContext } from './context/combobox-group.context';
import { comboboxGroupStyles } from './styles/combobox-group.styles';
import type { ComboboxGroupPropsInterface } from './types/combobox-group.types';

/**
 * @since 10.0.0
 */
export const ComboboxGroup = forwardRef<HTMLDivElement, ComboboxGroupPropsInterface>(
  (props: ComboboxGroupPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const styles = css(comboboxGroupStyles, cssProp);
    const id = useId();
    const contextValue = useMemo(() => ({ id }), [id]);
    return (
      <ComboboxGroupContext.Provider value={contextValue}>
        <div
          ref={forwardedRef}
          data-c11n-component="Combobox.Group"
          data-c11n-version={__C11N_VERSION__}
          className={cx('c11n', 'c11n_combobox__group', styles, className)}
          role="group"
          aria-labelledby={id}
          {...rest}
        />
      </ComboboxGroupContext.Provider>
    );
  },
);

ComboboxGroup.displayName = 'Combobox.Group';
